var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from '@xstyled/styled-components';
import { th } from '@xstyled/styled-components';
export var StyledCard = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n  padding: 20px;\n  border: 1px solid;\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: 12px;\n  width: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  display: ", ";\n  padding: 20px;\n  border: 1px solid;\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: 12px;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var display = _a.display;
    return display;
}, function (_a) {
    var bg = _a.bg;
    return (bg ? th.color(bg) : 'white');
}, th.color('lightGray6'), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && "max-width: ".concat(maxWidth, ";");
}, function (_a) {
    var hasOnClick = _a.hasOnClick;
    return hasOnClick && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        border-color: ", ";\n      }\n    "])), th.color('gray1'));
});
var templateObject_1, templateObject_2;
